// src/components/Common/CarouselItem.tsx
import React from 'react';
import type { ReactNode } from 'react';

interface CarouselItemProps {
  children: ReactNode;
  width?: string; // Tailwind width class (default: 'w-72')
  className?: string;
}

const CarouselItem: React.FC<CarouselItemProps> = ({
  children,
  width = 'w-64 sm:w-72 lg:w-80',
  className = '',
}) => {
  return (
    <div className={`flex-none ${width} transform transition-all duration-300 hover:scale-105 ${className}`}>
      {children}
    </div>
  );
};

export default CarouselItem;